<div *ngIf="exist;else attente"></div>
<ng-template #attente>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
  <mat-select name="ff" #abc="ngModel" [(ngModel)]="ecArtCar_Val"
      (selectionChange)="onvalueCaracteristiqueChange($event.value)"
      placeholder="Introduire une valeur" required>
      <mat-option *ngFor="let car of valueCaracteristique" [value]="car.ecArtCarValList_Id">{{car.ecArtCarValList_Label}}</mat-option>
  </mat-select>
